import pick from 'lodash/pick';
import _ from 'underscore';
/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import { SaveState } from 'bundles/groups/constants/SettingConstants';

const SERIALIZED_PROPS = [
  'group',
  'course',
  'groupSummary',
  'groupSaveState',
  'linkedGroupModels',
  'privateSessionsWithGroups',
  'privateSessionsById',
  'privateGroupIds',
  'groupLoadError',
];

/**
 * Store for managing group data, and private group-sessions as part
 * of the /groups to /teach migration effort.
 * @type {FluxibleStore}
 */
const GroupStore = createStore({
  storeName: 'GroupStore',

  initialize() {
    this.group = null;
    this.course = null;
    this.groupSummary = null;
    this.groupSaveState = SaveState.IDLE;
    this.linkedGroupModels = [];

    // private session-group data
    this.privateSessionsWithGroups = [];
    this.privateSessionsById = {};
    this.privateGroupIds = [];
    this.groupLoadError = false;
  },

  dehydrate() {
    return pick(this, ...SERIALIZED_PROPS);
  },

  rehydrate(state: $TSFixMe) {
    Object.assign(this, state);
  },

  getGroup() {
    return this.group;
  },

  getScopeData() {
    return this.course;
  },

  getGroupSummary() {
    return this.groupSummary;
  },

  getSaveState() {
    return this.groupSaveState;
  },

  getGroupLoadError() {
    return this.groupLoadError;
  },

  // TODO(dli): refactor to support multiple courses/sessions/s12ns
  getLaunchedAt() {
    if (_(this.linkedGroupModels).isEmpty()) {
      return -1;
    }

    const {
      'onDemandCourses.v1': onDemandCourses,
      'onDemandSessions.v1': onDemandSessions,
      'onDemandSpecializations.v1': onDemandSpecializations,
    } = this.linkedGroupModels;

    return (
      (onDemandCourses && onDemandCourses[0] && onDemandCourses[0].launchedAt) ||
      (onDemandSessions && onDemandSessions[0] && onDemandSessions[0].startedAt) ||
      (onDemandSpecializations && onDemandSpecializations[0] && onDemandSpecializations[0].launchedAt) ||
      0
    );
  },

  getGroupSummariesForCourse() {
    return this.groupSummariesForCourse;
  },

  getGroupIdOfPrivateSession(sessionId: $TSFixMe) {
    return (
      this.privateSessionsById && this.privateSessionsById[sessionId] && this.privateSessionsById[sessionId].groupId
    );
  },

  getPrivateGroupSummaries() {
    return this.privateGroupSummaries;
  },

  getPrivateSessionsWithGroups() {
    return this.privateSessionsWithGroups;
  },

  getPrivateSessionsById() {
    return this.privateSessionsById;
  },

  hasPrivateSessionGroups() {
    return this.privateSessionsWithGroups.length > 0;
  },

  hasPrivateGroups() {
    return this.privateGroupIds.length > 0;
  },

  getCurrentSessionId() {
    return this.currentSessionId;
  },
});

GroupStore.handlers = {
  GROUP_LOADED({ group }: $TSFixMe) {
    this.group = group;
    this.groupLoadError = false;
    this.emitChange();
  },

  RECEIVE_COURSE(course: $TSFixMe) {
    this.course = course;
    this.emitChange();
  },

  GROUP_SUMMARY_LOADED({ groupSummary, linkedGroupModels }: $TSFixMe) {
    this.groupSummary = groupSummary;
    this.linkedGroupModels = linkedGroupModels;
    this.emitChange();
  },

  GROUP_SAVING() {
    this.groupSaveState = SaveState.SAVING;
    this.emitChange();
  },

  GROUP_SAVED({ group }: $TSFixMe) {
    this.groupSaveState = SaveState.SUCCESS;
    this.group = group;
    this.emitChange();
  },

  GROUP_SAVE_ERROR() {
    this.groupSaveState = SaveState.ERROR;
    this.emitChange();
  },

  GROUP_LOAD_ERROR() {
    this.groupLoadError = true;
    this.emitChange();
  },

  RECEIVE_PRIVATE_SESSIONS_WITH_GROUPS({ sessions }: $TSFixMe) {
    this.privateSessionsWithGroups = sessions;
    this.currentSessionId = sessions[0] && sessions[0].id; // first session is the current session initially

    // store an id-indexed version for easy lookups in downstream components
    this.privateSessionsById = _(this.privateSessionsWithGroups).indexBy('id');

    this.emitChange();
  },

  RECEIVE_PRIVATE_GROUP_IDS({ privateGroupIds }: $TSFixMe) {
    this.privateGroupIds = privateGroupIds;

    this.emitChange();
  },

  RECEIVE_CURRENT_SESSION_ID({ sessionId }: $TSFixMe) {
    this.currentSessionId = sessionId;
    this.emitChange();
  },
};

export { GroupStore };
export default GroupStore;
